import { a as d } from "./chunk-BaseElement-CJM6sCUz.js";
class p extends d {
  constructor() {
    var t;
    super(), this.form = this.querySelector("form"), this.status = this.querySelector("[data-status]"), this.thankYouMessage = ((t = this.status) == null ? void 0 : t.textContent) || "", this.stepHandler = this.getAttribute("step-handler-elem"), this.previousButtonSelector = this.getAttribute("data-prev"), this.nextButtonSelector = this.getAttribute("data-next"), this.step = 0, this.hCaptchaLoaded = !1;
  }
  connectedCallback() {
    if (this.form && (this.setupDynamicFiltering(), this.hCaptchaListener(), this.form.addEventListener("submit", (t) => {
      t.preventDefault(), this.submit(t);
    }), this.stepHandler)) {
      const t = document.querySelector(this.stepHandler);
      t && this.trackSteps(t);
    }
  }
  hCaptchaListener() {
    this.hCaptchaLoaded || this.form.querySelector(".h-captcha") && (this.form.addEventListener("click", () => {
      this.hCaptchaLoaded || this.loadHcaptcha();
    }), this.querySelectorAll("input, button").forEach((t) => {
      this.hCaptchaLoaded || t.addEventListener("focus", () => {
        this.loadHcaptcha();
      });
    }));
  }
  loadHcaptcha() {
    this.hCaptchaLoaded = !0;
    const t = document.createElement("script");
    t.src = "https://js.hcaptcha.com/1/api.js", t.async = !0, t.defer = !0, document.head.appendChild(t);
  }
  trackSteps(t) {
    var i, e;
    this.previousButton = document.querySelector(this.previousButtonSelector), this.nextButton = document.querySelector(this.nextButtonSelector), (i = this.nextButton) == null || i.addEventListener("click", () => {
      this.step += 1, t.setAttribute("data-step", this.step);
    }), (e = this.previousButton) == null || e.addEventListener("click", () => {
      this.previousButton.hasAttribute("data-reset") ? (this.step = 0, t.setAttribute("data-step", this.step), this.removeAttribute("data-submitted")) : (this.step -= 1, t.setAttribute("data-step", this.step));
    });
  }
  setupDynamicFiltering() {
    this.querySelectorAll("[data-filter-key]").forEach((i) => {
      const e = i.getAttribute("data-filter-key"), o = this.querySelector(`[data-filter-target="${e}"]`);
      if (!o) return;
      const r = Array.from(o.options);
      i.addEventListener("change", () => {
        const c = i.options[i.selectedIndex].dataset.filterTerm || i.value;
        o.innerHTML = "";
        const a = r.filter((s) => s.innerText.includes(c));
        if (a.length)
          a.forEach((s) => o.appendChild(s));
        else {
          const s = document.createElement("option");
          s.textContent = "No options available", s.disabled = !0, s.selected = !0, o.appendChild(s);
        }
      });
    });
  }
  validateCustomSelects() {
    let t = !0;
    return this.form.querySelectorAll("custom-select").forEach((e) => {
      var o;
      if (e.classList.remove("custom-select-error"), e.required && !e.value) {
        t = !1, e.classList.add("custom-select-error");
        const r = e.closest("custom-select") || e.closest("[custom-select-wrapper]");
        r && (r.scrollIntoView({ behavior: "smooth", block: "center" }), (o = r.focus) == null || o.call(r));
      }
    }), t;
  }
  async submit(t) {
    var c;
    if (!this.validateCustomSelects()) {
      this.setAttribute("data-submitted", "error"), this.status.textContent = "Please fill in all required fields.";
      return;
    }
    const e = new FormData(t.target);
    this.form.querySelectorAll('input[type="time"]').forEach((a) => {
      const s = a.value;
      if (s) {
        const [n, h] = s.split(":").map(Number), u = n >= 12 ? "PM" : "AM", l = `${n % 12 === 0 ? 12 : n % 12}:${h.toString().padStart(2, "0")}${u}`;
        e.set(a.name, l);
      }
    });
    const r = (c = document.querySelector(
      "textarea[name=h-captcha-response]"
    )) == null ? void 0 : c.value;
    r && e.set("h-captcha-response", r), fetch(t.target.action, {
      method: this.form.method,
      body: e,
      headers: {
        Accept: "application/json"
      }
    }).then((a) => {
      var s;
      if (a.ok) {
        if (this.setAttribute("data-submitted", "success"), this.thankYouMessage && this.status && (this.status.textContent = this.thankYouMessage), this.form.reset(), this.stepHandler) {
          const n = document.querySelector(this.stepHandler);
          this.step += 1, n.setAttribute("data-step", this.step), (s = this.previousButton) == null || s.setAttribute("data-reset", "");
        }
      } else
        a.json().then((n) => {
          if (this.setAttribute("data-submitted", "error"), Object.hasOwn(n, "errors")) {
            if (!this.status)
              return;
            this.status.textContent = n.errors.map((h) => h.message).join(", ");
          } else {
            if (!this.status)
              return;
            this.status.textContent = "Oops! There was a problem submitting your form";
          }
        });
    }).catch((a) => {
      console.log(a), this.setAttribute("data-submitted", "error"), this.status.textContent = "Oops! There was a problem submitting your form";
    });
  }
}
window.customElements.define("formspree-form", p);
export {
  p as FormSpreeForm
};
